
              import hljs from "highlight.js"
              export default {
                mounted() { this.run() },
                updated() { this.run() },
                run() {
                  this.el.querySelectorAll('[data-snippet-line]:not([data-hl])').forEach(el => {
                    const lang = el.dataset.lang
                    if (lang && hljs.getLanguage(lang)) {
                      try {
                        el.innerHTML = hljs.highlight(el.textContent, { language: lang, ignoreIllegals: true }).value
                      } catch (_) {}
                    }
                    el.setAttribute('data-hl', '1')
                  })
                }
              }
            